import { render } from "./PlayoutViewV2.vue?vue&type=template&id=150efa0c"
import script from "./PlayoutViewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutViewV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TVPlayoutDash/PlayoutViewV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "150efa0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('150efa0c', __exports__)) {
    api.reload('150efa0c', __exports__)
  }
  
  module.hot.accept("./PlayoutViewV2.vue?vue&type=template&id=150efa0c", () => {
    api.rerender('150efa0c', render)
  })

}


export default __exports__